import { Component } from '@angular/core';
import { CustomerDocumentsListConfigService } from '../../services/customer-documents-list-config/customer-documents-list-config.service';

@Component({
    selector: 'lib-customer-documents-list',
    template: '<lib-filter-list [configService]="customerDocumentsListConfigService"></lib-filter-list>',
    styleUrls: ['./customer-documents-list.component.scss'],
    standalone: false
})
export class CustomerDocumentsListComponent {
  constructor(public customerDocumentsListConfigService: CustomerDocumentsListConfigService) {}
}
